import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import * as classes1 from '../../../components/BobActionMenu.module.css';
import classes from './SensorPanel.module.css';
const BobChartTypeMenu = ({
    ...props
}) => {

  
    const [menuOpen, setMenuOpen] = useState(false);
    const handleToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const handleClickAway = () => {
        setMenuOpen(false);
    };

    const clickOperator = (e,val) => {
        handleClickAway();
        props.setChartType(val);
    };

    return (
        <ClickAwayListener
            onClickAway={() => handleClickAway()}
        >
            <div className={classes.SensorFilterContainer} style={{marginTop: '.9rem'}}>
                <React.Fragment>
               
                    <Button
                        onClick={handleToggle}
                        style={{textTransform: 'none !important'}}
                        className={`action-dropdown conditional_dropdown`}
                    >
                        {props.chartType}
                        <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                    </Button> 
                    {menuOpen ?
                        <Paper style={{right: 'unset'}} className={classes1.BobActionMenu}>                         
                            <React.Fragment>
                                <Button style={{fontSize: '1.2rem'}} onClick={(e) => clickOperator(e, 'Line')}>
                                    Line
                                </Button>
                            </React.Fragment>  
                            <React.Fragment>
                                <Button style={{fontSize: '1.2rem'}} onClick={(e) => clickOperator(e, 'Bar')}>
                                    Bar
                                </Button>
                            </React.Fragment>             
                    
                        </Paper>
                        :''}
                </React.Fragment>
            </div>
        </ClickAwayListener>
    );
};

export default BobChartTypeMenu;
